import { IconButton, Stack, Badge, Popover, Box, TextField, List, ListItemButton } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { useEffect, useState } from "react";
import api from "../services/api";


export default function InspectorFilter(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [inspectores, setInspectores] = useState([]);
  const [filter, setFilter] = useState([]);
  const open = Boolean(anchorEl);

  const onClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    api.get('/admins?funcao=Inspector&perPage=200')
      .then(response => {
        // setInspectores(response.data.Admins)
        setInspectores(response.data.Admins.sort((a, b) => a?.dadosPessoais?.nome.localeCompare(b?.dadosPessoais?.nome)));
        setFilter(response.data.Admins)
      }).catch(err => '')
  }, [])

  const handleSearch = (event) => {
    const value = event.target.value;
    setInspectores(filter.filter((inspector) => inspector?.dadosPessoais?.nome.toLowerCase().includes(value.toLowerCase())));
  }

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <IconButton
        size="small"
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <Badge
          color="primary"
          variant="dot"
          invisible={!props.inspectorId}
        >
          <FilterListIcon fontSize="small" />
        </Badge>
      </IconButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Box minWidth={200}>

          <TextField
            type="text"
            label="Filtro por Inspector"
            style={{ width: '100%' }}
            size="small"
            name="inspectorId"
            variant="outlined"
            onChange={handleSearch}
          // value={props.inspectorId}
          />

          <List component="nav" aria-label="secondary mailbox folder">
            <ListItemButton
              selected={props.inspectorId === ""}
              onClick={(event) => {
                props.setInspectorId("");
                onClose();
              }}
            >
              Geral
            </ListItemButton>
            {inspectores?.map((inspector) => (
              <ListItemButton
                key={inspector._id}
                selected={props.inspectorId === inspector._id}
                onClick={(event) => {
                  props.setInspectorId(inspector._id);
                  onClose();
                }}
              >
                {inspector?.dadosPessoais?.nome}
              </ListItemButton>
            ))}

          </List>
        </Box>
      </Popover>
    </Stack>
  );
};


